"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withProject = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const lodash_1 = __importDefault(require("lodash"));
const ProjectErrorActorPage_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/noData/ProjectErrorActorPage");
const withProject = (wrappedComponent) => {
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const [contextGetActorResult, setContextGetActorResult] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        (async () => {
            const actorResult = await projectsContext.getActor(projectApiKey);
            setContextGetActorResult(actorResult);
        })();
    }, [projectsContext.getActor, projectsContext]);
    // const actorResult = projectsContext.getActor(projectApiKey);
    const element = (0, react_1.useMemo)(() => {
        return wrappedComponent;
    }, []);
    if ((contextGetActorResult === null || contextGetActorResult === void 0 ? void 0 : contextGetActorResult.error) && !lodash_1.default.isNil(contextGetActorResult === null || contextGetActorResult === void 0 ? void 0 : contextGetActorResult.error)) {
        return React.createElement(ProjectErrorActorPage_1.ProjectErrorActorPage, { error: contextGetActorResult.error });
    }
    return element;
};
exports.withProject = withProject;
